module.exports = __webpack_public_path__ + "img/pantalla-1-1-slider.65c2b83f.png";